// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-mote {
  text-align: left;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  white-space: normal;
  margin-top: 0px;
}
.mini-mote .image {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.mini-mote .image .image-placeholder {
  position: relative;
  bottom: 0;
  z-index: 0;
  overflow: hidden;
}
.mini-mote .image .image-placeholder svg-icon {
  font-size: 70px;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.8;
}
.mini-mote .image h2 {
  line-height: 30px;
  font-size: 20px;
  margin: 0;
  max-width: 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  position: absolute;
  font-weight: 700;
  left: 0;
  top: 0;
  padding: 10px;
  color: white;
  text-shadow: 0 2px 15px rgb(50, 50, 50), 0 2px 5px rgba(0, 0, 0, 0.8), 0 0 10px rgb(50, 50, 50);
}
.mini-mote .image h2 svg-icon {
  vertical-align: middle;
}
.mini-mote .image h2::after {
  border: none;
}
.mini-mote .image .hide-title {
  display: none;
}
.mini-mote .image .distance {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px;
  color: white;
  border-bottom-right-radius: 10px;
}
.mini-mote .image .actions {
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.075), rgba(0, 0, 0, 0.233));
  padding: 10px;
  padding-top: 10px;
  text-align: left;
  box-sizing: border-box;
  z-index: 1;
}
.mini-mote .image .love {
  position: relative;
  display: inline-block;
  font-size: 28px;
  color: white;
  transition: 0.2s;
  line-height: 1em;
  height: 1em;
  vertical-align: bottom;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  pointer-events: initial;
  cursor: pointer;
  outline: none;
  /** Disable touch box **/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: rgba(0, 0, 0, 0);
}
.mini-mote .image .love:hover {
  transform: scale(1.1);
  transition: 0.2s;
}
.mini-mote .image .love.loved {
  transform: scale(1.1);
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  color: #dd4b39;
  transition: 250ms;
}
.mini-mote .image .motes-button {
  pointer-events: initial;
  cursor: pointer;
  position: absolute;
  right: 10px;
  bottom: 0px;
}
.mini-mote .image .route svg-icon {
  margin-right: 10px;
}

.details {
  padding: var(--motes-padding);
}
.details .truncate-text p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  font-size: 18px;
  line-height: 20px;
  overflow: hidden;
  text-align: left;
  -webkit-box-orient: vertical !important;
  min-height: 40px;
  margin: 0;
}

.check-mark {
  font-size: 38px;
  color: white;
  float: right;
  margin-bottom: -10px;
}

.check-mark ::ng-deep .svg-bg {
  fill: rgba(255, 255, 255, 0);
}

.check-mark-enabled ::ng-deep .svg-bg {
  fill: white;
}

.check-mark-bg {
  height: 1em;
  width: 1em;
  color: white;
}

.check-mark-enabled {
  transition: 0;
  color: rgb(60, 186, 84);
}

.show-details {
  transition: 150ms ease-in;
}

.hide-details {
  transition: 150ms;
  height: 0px;
  margin-bottom: 0px;
  margin-top: -10px;
}

@media only screen and (max-height: 400px) {
  .details {
    transition: 150ms;
    height: 0px;
    margin-bottom: 0px;
    margin-top: -10px;
  }
}
.ng-content {
  text-align: center;
}

@keyframes arrowright {
  0% {
    -webkit-transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(10%);
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/mini-mote/mini-mote.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,yBAAA;EAGA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAAR;AAEQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;AAAZ;AAGY;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AADhB;AAIgB;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;AAFpB;AAMY;EACI,iBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;EACA,+FAAA;AAJhB;AAMgB;EACI,sBAAA;AAJpB;AAMgB;EACI,YAAA;AAJpB;AAQY;EACI,aAAA;AANhB;AASY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,8BAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;AAPhB;AAUY;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,+FAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;AAThB;AAYY;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,6CAAA;EACA,0CAAA;AAVhB;AAaY;EACI,qBAAA;EACA,gBAAA;AAXhB;AAcY;EACI,qBAAA;EACA,uCAAA;EACA,cAAA;EACA,iBAAA;AAZhB;AAeY;EACI,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAbhB;AAgBY;EACI,kBAAA;AAdhB;;AAoBI;EACI,6BAAA;AAjBR;AAmBQ;EACI,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,gBAAA;EAEA,SAAA;AAlBZ;;AAsBI;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;AAnBR;;AAsBI;EACI,4BAAA;AAnBR;;AAsBI;EACI,WAAA;AAnBR;;AAsBI;EACI,WAAA;EACA,UAAA;EACA,YAAA;AAnBR;;AAsBI;EACI,aAAA;EACA,uBAAA;AAnBR;;AAsBI;EACI,yBAAA;AAnBR;;AAsBI;EACI,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAnBR;;AAuBI;EACI;IACI,iBAAA;IACA,WAAA;IACA,kBAAA;IACA,iBAAA;EApBV;AACF;AAuBI;EACI,kBAAA;AArBR;;AAwBI;EACI;IAAK,gCAAA;EApBX;EAqBM;IAAO,kCAAA;EAlBb;AACF","sourcesContent":["\n    .mini-mote {\n        text-align: left;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n        white-space: normal;\n        margin-top: 0px;\n        \n        .image {\n            position: relative;\n            overflow: hidden;\n            cursor: pointer;\n            // border-radius: var(--border-radius);\n\n            .image-placeholder {\n                position: relative;\n                bottom: 0;\n                z-index: 0;\n                overflow: hidden;\n                // border-radius: var(--border-radius);\n                \n                svg-icon {\n                    font-size: 70px;\n                    color: white;\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n                    opacity: .8;\n                }\n            }\n\n            h2 {\n                line-height: 30px;\n                font-size: 20px;\n                margin: 0;\n                max-width: 100%;\n                display: inline-block;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                box-sizing: border-box;\n                position: absolute;\n                font-weight: 700;\n                left: 0;\n                top: 0;\n                padding: 10px;\n                color: white;\n                text-shadow: 0 2px 15px rgba(50,50,50,1), 0 2px 5px rgba(0,0,0,.8), 0 0 10px rgba(50,50,50,1);\n\n                svg-icon {\n                    vertical-align: middle;\n                }\n                &::after {\n                    border: none;\n                }\n            }\n\n            .hide-title {\n                display: none;\n            }\n            \n            .distance {\n                position: absolute;\n                top: 0;\n                left: 0;\n                background: rgba(0,0,0,.5);\n                padding: 10px;\n                color: white;\n                border-bottom-right-radius: 10px;\n            }\n\n            .actions {\n                position: absolute;\n                bottom: 0px;\n                width: 100%;\n                // background-color: rgba(0, 0, 0, 0.075);\n                background: linear-gradient(rgba(255,255,255,0),rgba(0, 0, 0, 0.075), rgba(0, 0, 0, 0.233));\n                padding: 10px;\n                padding-top: 10px;\n                text-align: left;\n                box-sizing: border-box;\n                z-index: 1;\n            }\n\n            .love {\n                position: relative;\n                display: inline-block;\n                font-size: 28px;\n                color: white;\n                transition: .2s;\n                line-height: 1em;\n                height: 1em;\n                vertical-align: bottom;\n                text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n                pointer-events: initial;\n                cursor: pointer;\n                outline: none;\n                /** Disable touch box **/\n                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n                -moz-tap-highlight-color: rgba(0, 0, 0, 0);\n            }\n\n            .love:hover {\n                transform: scale(1.1);\n                transition: .2s;\n            }\n\n            .love.loved {\n                transform: scale(1.1);\n                text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n                color: #dd4b39;\n                transition: 250ms;\n            }\n\n            .motes-button {\n                pointer-events: initial;\n                cursor: pointer;\n                position: absolute;\n                right: 10px;\n                bottom: 0px;\n            }\n\n            .route svg-icon  {\n                margin-right: 10px;\n            }\n        }\n\n    }\n\n    .details {\n        padding: var(--motes-padding);\n\n        .truncate-text p {\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            font-size: 18px;\n            line-height: 20px;\n            overflow: hidden;\n            text-align: left;\n            -webkit-box-orient: vertical !important;\n            min-height: 40px; // text-line = 20px, 2 lines = 40px\n            // margin-bottom: var(--motes-padding);\n            margin: 0;\n        }\n    }\n\n    .check-mark {\n        font-size: 38px;\n        color: white;\n        float: right;\n        margin-bottom: -10px;\n\n    }\n    .check-mark ::ng-deep .svg-bg {\n        fill: #ffffff00;\n    }\n\n    .check-mark-enabled ::ng-deep .svg-bg {\n        fill: white;\n    }\n\n    .check-mark-bg {\n        height: 1em;\n        width: 1em;\n        color: white;\n    }\n\n    .check-mark-enabled {\n        transition: 0;\n        color: rgb(60, 186, 84);\n    }\n\n    .show-details {\n        transition: 150ms ease-in;\n    }\n\n    .hide-details {\n        transition: 150ms;\n        height: 0px;\n        margin-bottom: 0px;\n        margin-top: -10px;\n    }\n\n    // Hide details when screen is very small (tilted horizontly on an old device)\n    @media only screen and (max-height: 400px) {\n        .details {\n            transition: 150ms;\n            height: 0px;\n            margin-bottom: 0px;\n            margin-top: -10px;\n        }\n    }\n\n    .ng-content {\n        text-align: center;\n    }\n\n    @keyframes arrowright {\n        0% { -webkit-transform: translateX(0) }\n        100% { -webkit-transform: translateX(10%) }\n    }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
